/**
 * Lazy load koszyka — pobiera licznik i zawartość dropdownu od razu po
 * załadowaniu strony. HTML strony jest statyczny (cache Cloudflare),
 * a aktualna zawartość koszyka przychodzi przez AJAX.
 *
 * Licznik (#mini-cart-count) aktualizuje się też przy każdym added_to_cart.
 */
export function initNavbarCartLazy() {
  const cartEl = document.querySelector('[data-cart-lazy]');
  if (!cartEl || !window.sebaNavbarAjax) return;

  const dropdown = cartEl.querySelector('.navbar-cart__dropdown');
  const countEl = document.getElementById('mini-cart-count');
  if (!dropdown || !countEl) return;

  function fetchCart() {
    fetch(window.sebaNavbarAjax.ajaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'action=seba_get_cart_menu',
      credentials: 'same-origin',
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.success || !data.data) return;
        if (data.data.count !== undefined) countEl.textContent = data.data.count;
        if (data.data.html) dropdown.innerHTML = data.data.html;
      })
      .catch(() => {});
  }

  fetchCart();

  // Odśwież po AJAX add-to-cart (np. przycisk "Dodaj do koszyka" bez przeładowania strony)
  if (typeof jQuery !== 'undefined') {
    jQuery(document.body).on('added_to_cart', fetchCart);
  }
}
